import React from 'react'

import ReactModal from '../ReactModal'
import { EDIT_SCHEDULE_MODAL } from '../../helpers/constants'
import { IMG } from '../../themes'

import {
  StyleEditRepeatModalHeader,
  StyleEditRepeatModalContent,
  StyleEditRepeatModalFooter,
} from './styles'

const EditModal = (props) => {
  const {
    isVisible,
    language,
    colorTheme,
    onClose,
    onSave,
  } = props

  return (
    <ReactModal isVisible={isVisible} width={420}>
      <StyleEditRepeatModalHeader>
        <label className='repeat-header-modal'>{EDIT_SCHEDULE_MODAL.HEADER[language]}</label>
        <img
          className='pointer'
          src={IMG['close.svg']}
          onClick={onClose}
          alt='close'
        />
      </StyleEditRepeatModalHeader>

      <StyleEditRepeatModalContent>
        <label className='description'>
          {EDIT_SCHEDULE_MODAL.DESCRIPTION[language]}
        </label>
      </StyleEditRepeatModalContent>

      <StyleEditRepeatModalFooter colorTheme={colorTheme}>
        <button
          className='submit-button'
          onClick={onSave}
        >
          {EDIT_SCHEDULE_MODAL.SAVE_BUTTON[language]}
        </button>
      </StyleEditRepeatModalFooter>
    </ReactModal>
  )
}

export default EditModal
